// extracted by mini-css-extract-plugin
module.exports = {"notes":"Notes_notes__3WNZ0"};